module.exports = ".form-group:first-child{\n  margin-top: 0px;\n}\n\n.form-group{\n  margin-top: 35px;\n}\n\n.col-md-4.align-top{\n  margin-top: 35px;\n}\n\n@media (min-width: 992px) {\n  .eoi .border-sec .col-md-4{\n    height: auto;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance-add-transaction/finance-add-transaction.component.css
// module id = ./src/app/finance-add-transaction/finance-add-transaction.component.css
// module chunks = main